module.exports = __webpack_public_path__ + "img/PorkBrazil.383c1223.png";